<template>
  <div>
    <navbar :hasSearch="true" />
    <div id="content">
      <div class="row">
        <div class="col-md-6 pb-3">
          <div class="card h-100">
            <ol class="breadcrumb lighten-4 my-auto">
              <router-link :to="{ name: 'landingPage' }">
                <li class="breadcrumb-item">
                  <a class="black-text" href="#">Home</a>
                  <i class="fa fa-angle-right mx-2" aria-hidden="true"></i>
                </li>
              </router-link>

              <li class="breadcrumb-item active font-weight-bold">
                On Hold Report
                <i class="fa fa-angle-right mx-2" aria-hidden="true"></i>
              </li>
            </ol>
          </div>
        </div>
        <quick-links></quick-links>
      </div>
      <div class="content_body">
        <div class="container-fluid no-pad">
          <div id="statementsOH">
            <div class="container-fluid no-pad">
              <div class="row">
                <div class="col-lg-12">
                  <div class="row">
                    <div class="col-sm-12">
                      <div class="border border-light rounded">
                        <div class="col-sm-12 bg-white brs">
                          <div class="row"></div>
                          <div class="row p-3">
                            <div class="col-sm-4 my-auto">
                              <h3 class="my-auto">On Hold Report</h3>
                            </div>
                            <div class="col-sm-8 my-auto">
                              <div class="my-auto float-right">
                                <p class="d-inline">Statements on Hold:</p>
                                <p class="d-inline font-weight-bold">{{filteredStatements.length}}</p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        class="border border-light rounded bg-white brs my-3 pl-3 pr-3 tbl-section"
                      >

                        <div class="row mt-3">
                          <div class="col-sm-4">
                          </div>
                          <div class="col-sm-4">
                            <div class="search_75">
                              <form class="input-group md-form form-sm">
                                <input
                                  class="form-control form-control-sm search"
                                  name="search"
                                  autocomplete="off"
                                  type="text"
                                  v-model="statementSearch"
                                />
                                <div class="input-group-btn mt-2">
                                  <a href="#" role="button">
                                    <i class="fa fa-search active" aria-hidden="true"></i>
                                  </a>
                                </div>
                              </form>
                            </div>
                          </div>
                        </div>

                        <div class="table-responsive-lg mt-4" :class="statementsOH.length > 0">
                          <b-table
                            id="statements-oh-table"
                            striped
                            fixed
                            :items="filteredStatements"
                            :fields="statementsOHFields"
                            :busy="loading"
                            :per-page="perPage"
                            :current-page="currentPage"
                          >
                            <template v-slot:table-busy>
                              <b-row align-h="center">
                                <propagate-loader class="mb-3" :color="primaryColour" :size="16"></propagate-loader>
                              </b-row>
                            </template>
                            <template slot="CustomerReference" slot-scope="data">
                              <router-link
                                :to="{path: '/dashboard/' + data.item.CustomerReference}"
                                target="_blank"
                                class="underline"
                              >{{data.item.CustomerReference}}</router-link>
                            </template>
                            <template slot="PeriodStarts" slot-scope="data">
                              <span
                                v-if="data.item.PeriodStarts"
                              >{{data.item.PeriodStarts | moment('DD.MM.YY')}}</span>
                              <span v-else>N/A</span>
                            </template>
                            <template slot="PeriodEnds" slot-scope="data">
                              <span
                                v-if="data.item.PeriodEnds"
                              >{{data.item.PeriodEnds | moment('DD.MM.YY')}}</span>
                              <span v-else>N/A</span>
                            </template>
                            <template
                              slot="CustomerName"
                              slot-scope="data"
                            >{{data.item.CustomerName}}</template>
                            <template
                              slot="NewCharges"
                              slot-scope="data"
                            >{{data.item.Amount | currency}}</template>
                            <template slot="StatusNarrative" slot-scope="row">
                              <div class="d-flex w-100">
                                <div
                                  class="col-11"
                                  v-if="row.item.hasOwnProperty('StatusNarrative')"
                                  style="white-space: pre-wrap;"
                                >{{row.item.StatusNarrative}}</div>
                                <div class="col-11" v-else style="white-space: pre-wrap;"></div>
                                <i
                                  v-if="!editMode"
                                  class="float-right pointer fas fa-edit mt-1 mx-2"
                                  @click="toggleEditMode(true, row)"
                                ></i>
                              </div>
                            </template>
                            <template slot="row-details" slot-scope="row">
                              <b-card>
                                <div class="row">
                                  <div class="col-12 col-lg-6">
                                    <div class="row">
                                      <div class="col-md-4">
                                        <p class="font-weight-bold">Reasons(s):</p>
                                      </div>
                                      <div class="col-md-8">
                                        <b-textarea
                                          v-model="row.item.StatusNarrative"
                                          class="form-control z-depth-1"
                                          rows="3"
                                          :maxlength="500"
                                        ></b-textarea>
                                        <div class="text-right small text-muted mt-1">
                                          {{ (row.item.StatusNarrative || '').length }}/500
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>

                                <hr class="mt-2" />

                                <div class="row">
                                  <div class="col-12">
                                    <div>
                                      <div class="text-left float-right">
                                        <b-btn
                                          @click="toggleEditMode(false, row)"
                                          class="btn btn-hc mr-1"
                                          :disabled="submitStatus == 'PENDING'"
                                        >Cancel</b-btn>
                                        <b-btn
                                          @click="saveChanges(row)"
                                          class="btn btn-hc ml-1"
                                          :disabled="submitStatus == 'PENDING'"
                                        >
                                          Save
                                          Changes
                                        </b-btn>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </b-card>
                            </template>
                            <template slot="Actions" slot-scope="data">
                              <a href="#" @click="viewStatement(data.item.DocumentUri)">
                                <span class="underline">View</span>
                              </a>
                              <a
                                class="d-block mt-2 mb-2 pointer"
                                @click="deleteStatement(data.item)"
                              >
                                <span class="underline">Delete</span>
                              </a>
                              <a class="d-block pointer" @click="releaseStatement(data.item)">
                                <span class="underline">Release</span>
                              </a>
                            </template>
                          </b-table>
                        </div>

                        <div
                          class="container-fluid no-pad"
                          v-if="filteredStatements.length > perPage"
                        >
                          <div class="d-flex overflow-auto my-3">
                            <b-pagination
                              class="my-auto d-flex justify-content-center align-items-center mx-auto"
                              v-model="currentPage"
                              :total-rows="filteredStatements.length"
                              :per-page="perPage"
                              aria-controls="statements-oh-table"
                              @input="scrollToTop()"
                            >
                              <template v-slot:first-text>
                                <i class="fas fa-angle-double-left fa-2x pointer"></i>
                              </template>
                              <template v-slot:prev-text>
                                <i class="fas fa-chevron-left fa-2x pointer"></i>
                              </template>
                              <template v-slot:next-text>
                                <i class="fas fa-chevron-right fa-2x pointer"></i>
                              </template>
                              <template v-slot:last-text>
                                <i class="fas fa-angle-double-right fa-2x pointer"></i>
                              </template>
                            </b-pagination>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- content close -->
</template>
<script>
import Navbar from "@/components/Navbar.vue";
import QuickLinks from "@/components/QuickLinks.vue";
import Swal from "sweetalert2";
import Vue from "vue";
import { _ } from "vue-underscore";
import _filters from "@/mixins/filters.js";

export default {
  components: {
    Navbar,
    QuickLinks,
  },
  mixins: [_filters],
  data() {
    return {
      submitStatus: null,
      perPage: 10,
      currentPage: 1,
      startDate: null,
      endDate: null,
      editMode: false,
      statementSearch: "",
      statementsOHFields: {
        CustomerReference: {
          label: "Customer Reference",
        },
        PeriodStarts: {
          label: "Bill From",
        },
        PeriodEnds: {
          label: "Bill To",
        },
        CustomerName: {
          label: "Customer Name",
        },
        NewCharges: {
          label: "Amount",
        },
        StatusNarrative: {
          label: "Reason(s)",
        },
        Actions: {
          label: "Actions",
        },
      },
    };
  },
  computed: {
    loading() {
      return this.$store.state.finances.loading;
    },
    primaryColour() {
      return Vue.config.honeycomb.theme;
    },
    accessToken() {
      return this.$auth.accessToken;
    },
    xsrfToken() {
      return this.$auth.xsrfToken;
    },
    moneybot() {
      return Vue.config.honeycomb.moneybot.domain;
    },
    results() {
      return this.$store.state.results;
    },
    statementsOH() {
      return _.sortBy(
        this.$store.state.finances.statementsOH,
        "PeriodStarts"
      ).reverse();
    },
    filteredStatements() {
      return this.statementsOH.filter((statement) => {
        return statement.CustomerName.match(
          new RegExp(this.statementSearch, "i")
        );
      });
    },
  },
  methods: {
    scrollToTop() {
      document.getElementById("statements-oh-table").scrollIntoView();
    },
    deleteStatement(statement) {
      Swal({
        title: "Are you sure you wish to delete this bill?",
        type: "warning",
        confirmButtonText: "Yes",
        confirmButtonColor: Vue.config.honeycomb.colour,
        showCancelButton: true,
        cancelButtonText: "Cancel",
      }).then((result) => {
        if (result.value) {
          this.$http
            .put(
              "https://" +
                Vue.config.honeycomb.billbotbillrun.domain +
                "/api/v1/BillRuns/undo",
              {
                BillIds: [statement.StatementId],
              },
              {
                withCredentials: true,
              }
            )
            .then((response) => {
              if (response.data.Processed.length > 0) {
                this.$snotify.success(`Success! Bill deleted.`);
                this.$store.dispatch("getOHReport");
              } else {
                this.$snotify.warning(
                  `Warning! Bill deletion failed to process.`
                );
              }
            })
            .catch((error) => {
              // Error
              if (error.response) {
                // The request was made and the server responded with a status code
                // that falls out of the range of 2xx
                this.submitStatus = "Error";
                if (error.response.data.MoreInformation.length > 0) {
                  error.response.data.MoreInformation.forEach((e) => {
                    this.$snotify.error(`${e.Error}`, {
                      timeout: 0,
                      closeOnClick: true,
                    });
                  });
                } else {
                  this.$snotify.error(
                    `${error.response.data.UserDescription}`,
                    {
                      timeout: 0,
                      closeOnClick: true,
                    }
                  );
                }
              } else if (error.request) {
                // The request was made but no response was received
                // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
                // http.ClientRequest in node.js
                this.submitStatus = "Error";
                this.$snotify.error(`No response received.`, {
                  timeout: 0,
                  closeOnClick: true,
                });
              } else {
                // Something happened in setting up the request that triggered an Error
                this.submitStatus = "Error";
                this.$snotify.error(`${error.message}`, {
                  timeout: 0,
                  closeOnClick: true,
                });
              }
            });
        }
      });
    },
    releaseStatement(statement) {
      this.$http
        .put(
          "https://" +
            Vue.config.honeycomb.billbot.domain +
            "/api/v1/OnHold/release/" +
            statement.StatementId,
          {
            BillIds: [statement.StatementId],
          },
          {
            withCredentials: true,
          }
        )
        .then(() => {
          this.$snotify.success(`Success! Bill released.`);
          this.$store.dispatch("getOHReport");
        })
        .catch((error) => {
          // Error
          if (error.response) {
            // The request was made and the server responded with a status code
            // that falls out of the range of 2xx
            this.submitStatus = "Error";
            if (error.response.data.MoreInformation.length > 0) {
              error.response.data.MoreInformation.forEach((e) => {
                this.$snotify.error(`${e.Error}`, {
                  timeout: 0,
                  closeOnClick: true,
                });
              });
            } else {
              this.$snotify.error(`${error.response.data.UserDescription}`, {
                timeout: 0,
                closeOnClick: true,
              });
            }
          } else if (error.request) {
            // The request was made but no response was received
            // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
            // http.ClientRequest in node.js
            this.submitStatus = "Error";
            this.$snotify.error(`No response received.`, {
              timeout: 0,
              closeOnClick: true,
            });
          } else {
            // Something happened in setting up the request that triggered an Error
            this.submitStatus = "Error";
            this.$snotify.error(`${error.message}`, {
              timeout: 0,
              closeOnClick: true,
            });
          }
        });
    },
    saveChanges(row) {
      var statement = row.item;
      this.submitStatus = "PENDING";
      this.$http
        .put(
          "https://" +
            Vue.config.honeycomb.billbot.domain +
            "/api/v1/OnHold/set",
          {
            StatementId: statement.StatementId,
            StatusNarrative: statement.hasOwnProperty("StatusNarrative")
              ? statement.StatusNarrative
              : null,
          },
          {
            withCredentials: true,
          }
        )
        .then(() => {
          this.submitStatus = "OK";
          this.editMode = false;
          row.toggleDetails();
          this.$snotify.success(`Success! On hold reason(s) updated.`);
          // this.$store.dispatch('getOHReport')
        })
        .catch((error) => {
          // Error
          this.submitStatus = "ERROR";
          Object.assign(statement, this.beforeEditingNarrative);
          this.editMode = false;
          if (error.response) {
            // The request was made and the server responded with a status code
            // that falls out of the range of 2xx
            if (error.response.data.MoreInformation.length > 0) {
              error.response.data.MoreInformation.forEach((e) => {
                this.$snotify.error(`${e.Error}`, {
                  timeout: 0,
                  closeOnClick: true,
                });
              });
            } else {
              this.$snotify.error(`${error.response.data.UserDescription}`, {
                timeout: 0,
                closeOnClick: true,
              });
            }
          } else if (error.request) {
            // The request was made but no response was received
            // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
            // http.ClientRequest in node.js
            this.$snotify.error(`No response received.`, {
              timeout: 0,
              closeOnClick: true,
            });
          } else {
            // Something happened in setting up the request that triggered an Error
            this.$snotify.error(`${error.message}`, {
              timeout: 0,
              closeOnClick: true,
            });
          }
        });
    },
    toggleEditMode(bool, row) {
      if (bool && !this.editMode) {
        this.beforeEditingNarrative = Object.assign({}, row.item);
      }
      row.toggleDetails();
      if (!bool && this.editMode) {
        if (!this.beforeEditingNarrative.hasOwnProperty("StatusNarrative")) {
          row.item.StatusNarrative = null;
        }
        Object.assign(row.item, this.beforeEditingNarrative);
      }
      this.editMode = bool;
    },
    last30Days: function() {
      this.endDate = new Date();
      this.startDate = new Date().setTime(
        new Date().getTime() - 3600 * 1000 * 24 * 30
      );
    },
    last6Months: function() {
      this.endDate = new Date();
      this.startDate = new Date().setTime(
        new Date().getTime() - 3600 * 1000 * 24 * 180
      );
    },
    last12Months: function() {
      this.endDate = new Date();
      this.startDate = new Date().setTime(
        new Date().getTime() - 3600 * 1000 * 24 * 365
      );
    },
    clearFilter: function() {
      this.startDate = null;
      this.endDate = null;
    },

    viewStatement(documentUri) {
      // Extract the statement ID from the DocumentUri on the SalesTransaction
      const urlParts = documentUri.split('/');
      const statementId = urlParts[urlParts.length - 2]; // Get the part before '/uri'

      this.$http
          .get(
              "https://" +
              this.$config.honeycomb.billbotstatements.domain +
              "/api/v1/statements/" +
              statementId +
              "/uri",
              {
                withCredentials: true
              }
          )
          .then((response) => {
                const finalUrl = response.data.url;
                window.open(finalUrl, "_blank");
              }
          )
          .catch((error) => {
            if (error.response) {
              this.$snotify.error(
                  `Error viewing statement: ${(error.response.data && error.response.data.UserDescription) || error.response.statusText}`,
                  {
                    timeout: 0,
                    closeOnClick: true,
                  }
              );
            } else if (error.request) {
              this.$snotify.error(`No response received.`, {
                timeout: 0,
                closeOnClick: true,
              });
            } else {
              this.$snotify.error(`${error.message}`, {
                timeout: 0,
                closeOnClick: true,
              });
            }
          });
    },
  },
  created() {
    this.$store.dispatch("getOHReport");
  },
};
</script>
